'use client';

import { LikeButton } from '@app/(default-layout)/s/[storyId]/_components/like-button';
import { AppInstallOrLoginActionsheet } from '@app/_components/app-install-or-login-actionsheet';
import { Paragraph, VStack } from '@styled-system/jsx';
import { useLocalState } from './use-local-state';

type Props = {
  storyId: string;
  likeCount: number;
};

export const LikeCountContainer = ({ storyId, likeCount }: Props) => {
  const {
    enableLike,
    currentLikeCount,
    sheetDescription,
    disableLogin,
    onClickLike,
    onClickLogin,
    onOpenAppClick,
    sheetModalDisclosure,
  } = useLocalState({
    storyId,
    likeCount,
  });

  return (
    <VStack w="100%" gap="4">
      <Paragraph fontSize="size_14" color="accent.700">
        この作品はいかがでしたか？
      </Paragraph>
      <LikeButton
        likeCount={currentLikeCount}
        enabled={enableLike}
        onClick={onClickLike}
      />
      <AppInstallOrLoginActionsheet
        description={sheetDescription}
        visibilityConfig={{
          disableLogin,
        }}
        isOpen={sheetModalDisclosure.isOpen}
        close={sheetModalDisclosure.onClose}
        onOpenAppClick={onOpenAppClick}
        onClickLogin={onClickLogin}
      />
    </VStack>
  );
};
